export const ATUALIZAR_IDIOMA = 'ATUALIZAR_IDIOMA';
export const atualizaIdioma = lang => ({
  type: ATUALIZAR_IDIOMA,
  payload: {
    lang: lang
  }
});
export const ATUALIZAR_AUTOTEXTO = 'ATUALIZAR_AUTOTEXTO';
export const atualizaAutotexto = atualizaAutotexto => ({
  type: ATUALIZAR_AUTOTEXTO,
  payload: {
    atualizaAutotexto: atualizaAutotexto
  }
});
export const SHOW_FADE_CARREGANDO = 'SHOW_FADE_CARREGANDO';
export const showFadeCarregando = showCarregando => ({
  type: SHOW_FADE_CARREGANDO,
  payload: {
    showCarregando: showCarregando
  }
});
export const CLOSE_CARREGANDO = 'CLOSE_CARREGANDO';
export const closeCarregando = closeCarregando => ({
  type: CLOSE_CARREGANDO,
  payload: {
    closeCarregando: closeCarregando
  }
});
export const SHOW_SPLASH = 'SHOW_SPLASH';
export const splash = splash => ({
  type: SHOW_SPLASH,
  payload: {
    splash: splash
  }
});
export const SHOW_FADE_MODAL = 'SHOW_FADE_MODAL';
export const showModal = showModal => ({
  type: SHOW_FADE_MODAL,
  payload: {
    showModal: showModal
  }
});
export const SHOW_ALERTA = 'SHOW_ALERTA';
export const showAlerta = (
  tipoAlerta,
  mensagemAlerta,
  timeoutAlerta,
  minWidth
) => ({
  type: SHOW_ALERTA,
  payload: {
    tipoAlerta: tipoAlerta,
    mensagemAlerta: mensagemAlerta,
    timeoutAlerta: timeoutAlerta,
    idAlerta: Math.random(),
    minWidth: minWidth
  }
});
export const AVANCAR_PAGINA_LISTAGEM = 'AVANCAR_PAGINA_LISTAGEM';
export const avancarPaginaListagem = pagina => ({
  type: AVANCAR_PAGINA_LISTAGEM,
  payload: {
    pagina: pagina
  }
});

export const ALTERAR_AUTOSAVE_TEXTO_LAUDO = 'ALTERAR_AUTOSAVE_TEXTO_LAUDO';
export const alterarAutoSaveTextolaudo = autosave => ({
  type: ALTERAR_AUTOSAVE_TEXTO_LAUDO,
  payload: {
    autoSaveAtivo: autosave
  }
});
export const EXAME_SELECIONADO = 'EXAME_SELECIONADO';
export const exameSelecionado = exame => ({
  type: EXAME_SELECIONADO,
  payload: {
    exameVincular: exame
  }
});
export const PREENCHER_TOTAL_MENSAGENS = 'PREENCHER_TOTAL_MENSAGENS';
export const preencherTotalMensagens = mensagens => ({
  type: PREENCHER_TOTAL_MENSAGENS,
  payload: {
    totalMensagens: mensagens
  }
});

export const BLOQUEAR_RECEBIMENTO = 'BLOQUEAR_RECEBIMENTO';
export const bloquearRecebimento = bloquear => ({
  type: BLOQUEAR_RECEBIMENTO,
  payload: {
    bloquearRecebimento: bloquear
  }
});
export const SET_TIMEOUT_TOTAL_MENSAGENS = 'SET_TIMEOUT_TOTAL_MENSAGENS';
export const setTimeoutTotalMensagens = timeout => ({
  type: SET_TIMEOUT_TOTAL_MENSAGENS,
  payload: {
    timeoutTotalMensagens: timeout
  }
});

export const MODAL_SOUL = 'MODAL_SOUL';
export const modalSoul = (status) => ({
  type: MODAL_SOUL,
  payload: {
    modalSoul:status,
  }
});
export const MUDAR_STATUS_MODAL_MENSAGEM = 'MUDAR_STATUS_MODAL_MENSAGEM';
export const mudarStatusModalMensagem = (status, laudo) => ({
  type: MUDAR_STATUS_MODAL_MENSAGEM,
  payload: {
    modalMensagens: status,
    laudoModalMensagens: laudo
  }
});
export const MUDAR_STATUS_MODAL_CERTIFICACAO_DIGITAL = 'MUDAR_STATUS_MODAL_CERTIFICACAO_DIGITAL';
export const mudarStatusModalCertificacaoDigital = (status) => ({
  type: MUDAR_STATUS_MODAL_CERTIFICACAO_DIGITAL,
  payload: {
    modalCertificacaoDigital: status,
  }
});
export const TOTAL_CERTIFICADOS_PENDENTES = 'TOTAL_CERTIFICADOS_PENDENTES';
export const preencherTotalCertificadosPendentes = (total) => ({
  type: TOTAL_CERTIFICADOS_PENDENTES,
  payload: {
    totalCertificadosPendentes: total,
  }
});
export const MUDAR_STATUS_MODAL_FATURAMENTO = 'MUDAR_STATUS_MODAL_FATURAMENTO';
export const mudarStatusModalFaturamento = status => ({
  type: MUDAR_STATUS_MODAL_FATURAMENTO,
  payload: {
    modalFaturamento: status
  }
});

export const MUDAR_STATUS_LAUDO_FATURADO = 'MUDAR_STATUS_LAUDO_FATURADO';
export const mudarStatusLaudoFaturado = status => ({
  type: MUDAR_STATUS_LAUDO_FATURADO,
  payload: {
    laudoFaturado: status
  }
});
export const MUDAR_STATUS_MODAL_RECOLHIMENTO_MULTI =
  'MUDAR_STATUS_MODAL_RECOLHIMENTO_MULTI';
export const mudarStatusModalRecolhimentoMulti = status => ({
  type: MUDAR_STATUS_MODAL_RECOLHIMENTO_MULTI,
  payload: {
    modalRecolhimentoMulti: status
  }
});
export const MUDAR_STATUS_MODAL_ENTREGA = 'MUDAR_STATUS_MODAL_ENTREGA';
export const mudarStatusModalEntrega = (status, item) => ({
  type: MUDAR_STATUS_MODAL_ENTREGA,
  payload: {
    modalEntrega: status,
    laudoEntrega: item
  }
});
export const MUDAR_STATUS_MODAL_IMPRIMIR = 'MUDAR_STATUS_MODAL_IMPRIMIR';
export const mudarStatusModalImprimir = (status, item) => ({
  type: MUDAR_STATUS_MODAL_IMPRIMIR,
  payload: {
    modalImprimir: status,
    laudoImprimir: item
  }
});
export const MUDAR_STATUS_MODAL_OBSERVACOES = 'MUDAR_STATUS_MODAL_OBSERVACOES';
export const mudarStatusModalObservacoes = (status, item) => ({
  type: MUDAR_STATUS_MODAL_OBSERVACOES,
  payload: {
    modalObservacoes: status,
    laudo: item
  }
});
export const PREENCHER_IMPRESSORAS = 'PREENCHER_IMPRESSORAS';
export const preencherImpressoras = impressoras => ({
  type: PREENCHER_IMPRESSORAS,
  payload: {
    impressoras: impressoras
  }
});
export const PREENCHER_EXAMES_CONCLUIDOS = 'PREENCHER_EXAMES_CONCLUIDOS';
export const preencherExamesConcluidos = exames => ({
  type: PREENCHER_EXAMES_CONCLUIDOS,
  payload: {
    exames: exames
  }
});
export const PREENCHER_MEDICOS = 'PREENCHER_MEDICOS';
export const preencherMedicos = medicos => ({
  type: PREENCHER_MEDICOS,
  payload: {
    medicos: medicos
  }
});
export const SET_MEDICO_PADRAO_FATURAMENTO = 'SET_MEDICO_PADRAO_FATURAMENTO';
export const setMedicoPadraoFaturamento = (ativo, medico) => ({
  type: SET_MEDICO_PADRAO_FATURAMENTO,
  payload: {
    medPadraoFat: medico,
    fatMedicoPadrao: ativo
  }
});
export const MUDAR_ETAPA = 'MUDAR_ETAPA';
export const mudarEtapa = etapa => ({
  type: MUDAR_ETAPA,
  payload: {
    etapa: etapa
  }
});
export const PREENCHER_FILTROS = 'PREENCHER_FILTROS';
export const preencherFiltro = filtros => ({
  type: PREENCHER_FILTROS,
  payload: {
    filtros: filtros
  }
});
export const PREENCHER_FILTROS_EXTERNO = 'PREENCHER_FILTROS_EXTERNO';
export const preencherFiltroExterno = filtros => ({
  type: PREENCHER_FILTROS_EXTERNO,
  payload: {
    filtrosExterno: filtros
  }
});
export const PREENCHER_FAVORITOS = 'PREENCHER_FAVORITOS';
export const preencherFavoritos = favoritos => ({
  type: PREENCHER_FAVORITOS,
  payload: {
    favoritos: favoritos
  }
});
export const PREENCHER_LISTAGEM = 'PREENCHER_LISTAGEM';
export const preencherListagem = listagem => ({
  type: PREENCHER_LISTAGEM,
  payload: {
    listagem: listagem
  }
});
export const PREENCHER_ORDENACAO = 'PREENCHER_ORDENACAO';
export const preencherOrdenacao = (ordenacao, sentidoOrdenacao) => ({
  type: PREENCHER_ORDENACAO,
  payload: {
    ordenacao: ordenacao,
    sentidoOrdenacao: sentidoOrdenacao
  }
});
export const ATUALIZAR_ALTURA = 'ATUALIZAR_ALTURA';
export const atualizarAltura = altura => ({
  type: ATUALIZAR_ALTURA,
  payload: {
    altura: altura
  }
});
export const ATUALIZAR_NUMERO_REGISTROS = 'ATUALIZAR_NUMERO_REGISTROS';
export const atualizarNumeroRegistros = (exibido, total) => ({
  type: ATUALIZAR_NUMERO_REGISTROS,
  payload: {
    listagemExibido: exibido,
    listagemTotal: total
  }
});
export const LOAD_LISTAGEM = 'LOAD_LISTAGEM';
export const loadListagem = load => ({
  type: LOAD_LISTAGEM,
  payload: {
    loadListagem: load
  }
});
export const ATUALIZAR_DETALHES = 'ATUALIZAR_DETALHES';
export const atualizarDetalhes = detalhes => ({
  type: ATUALIZAR_DETALHES,
  payload: {
    detalhes: detalhes
  }
});

export const ATUALIZAR_LAUDO_DETALHES = 'ATUALIZAR_LAUDO_DETALHES';
export const atualizarLaudoDetalhes = laudo => ({
  type: ATUALIZAR_LAUDO_DETALHES,
  payload: {
    laudo: laudo
  }
});

export const PREENCHER_TEXTO_PROTOCOLO_MATERIAL =
  'PREENCHER_TEXTO_PROTOCOLO_MATERIAL';
export const preencherTextoProtocoloMaterial = texto => ({
  type: PREENCHER_TEXTO_PROTOCOLO_MATERIAL,
  payload: {
    textoProtocoloEntregaMaterial: texto
  }
});
export const PREENCHER_SELECT_COLORACAO = 'PREENCHER_SELECT_COLORACAO';
export const preencherSelectColoracao = coloracoes => ({
  type: PREENCHER_SELECT_COLORACAO,
  payload: {
    coloracoes: coloracoes
  }
});
export const PREENCHER_SELECT_ANTIGENOS = 'PREENCHER_SELECT_ANTIGENOS';
export const preencherSelectAntigenos = antigenos => ({
  type: PREENCHER_SELECT_ANTIGENOS,
  payload: {
    antigenos: antigenos
  }
});
export const ADICIONAR_FRASCO = 'ADICIONAR_FRASCO';
export const adicionarFrasco = frascosGravados => ({
  type: ADICIONAR_FRASCO,
  payload: {
    frascosGravados: frascosGravados
  }
});
export const ADICIONAR_NOVO_FRASCO = 'ADICIONAR_NOVO_FRASCO';
export const adicionarNovoFrasco = frascosNovos => ({
  type: ADICIONAR_NOVO_FRASCO,
  payload: {
    frascosNovos: frascosNovos
  }
});
export const ATUALIZAR_LAUDO_SELECIONADO = 'ATUALIZAR_LAUDO_SELECIONADO';
export const atualizarLaudoSelecionado = laudoSelecionado => ({
  type: ATUALIZAR_LAUDO_SELECIONADO,
  payload: {
    laudoSelecionado: laudoSelecionado
  }
});
export const PREENCHER_ATALHO = 'PREENCHER_ATALHO';
export const preencherAtalho = atalho => ({
  type: PREENCHER_ATALHO,
  payload: {
    atalho: atalho
  }
});
export const EDITOR_CARREGADO = 'EDITOR_CARREGADO';
export const editorCarregado = editorCarregado => ({
  type: EDITOR_CARREGADO,
  payload: {
    editorCarregado: editorCarregado
  }
});

export const SHOW_EDITOR = 'SHOW_EDITOR';
export const showEditor = showEditor => ({
  type: SHOW_EDITOR,
  payload: {
    showEditor: showEditor
  }
});
export const TEXTO_INICIAL = 'TEXTO_INICIAL';
export const textoInicial = textoInicial => ({
  type: TEXTO_INICIAL,
  payload: {
    textoInicial: textoInicial
  }
});
export const AUTO_SAVE_EDITOR = 'AUTO_SAVE_EDITOR';
export const autoSaveEditor = ativo => ({
  type: AUTO_SAVE_EDITOR,
  payload: {
    autosaveEditor: ativo
  }
});
export const ETAPA_ATUAL = 'ETAPA_ATUAL';
export const etapaAtual = etapaAtual => ({
  type: ETAPA_ATUAL,
  payload: {
    etapaAtual: etapaAtual
  }
});
export const ARGUMENTOS_SALVAR_ETAPA_LAUDO = 'ARGUMENTOS_SALVAR_ETAPA_LAUDO';
export const argumentosSalvarEtapaLaudo = objeto => ({
  type: ARGUMENTOS_SALVAR_ETAPA_LAUDO,
  payload: {
    laudarEtapaRequest: objeto
  }
});
export const ATUALIZAR_LARGURA_EDITOR = 'ATUALIZAR_LARGURA_EDITOR';
export const atualizarLarguraEditor = larguraEditor => ({
  type: ATUALIZAR_LARGURA_EDITOR,
  payload: {
    larguraEditor: larguraEditor
  }
});
export const ALTERAR_VISIBILIDADE_ABAS = 'ALTERAR_VISIBILIDADE_ABAS';
export const alterarVisibilidadeAbas = ({
  visibilidadeListaLaminas,
  visibilidadeAutotexto,
  visibilidadeListagemAnexo,
  visibilidadeLaudosAnteriores,
  visibilidadeFrascos,
  visibilidadeHistoricoLaudo,
  visibilidadeMultiplosExame
}) => ({
  type: ALTERAR_VISIBILIDADE_ABAS,
  payload: {
    visibilidadeListaLaminas,
    visibilidadeAutotexto,
    visibilidadeListagemAnexo,
    visibilidadeLaudosAnteriores,
    visibilidadeFrascos,
    visibilidadeHistoricoLaudo,
    visibilidadeMultiplosExame
  }
});
export const ATUALIZAR_LISTAGEM_MULTIPLOS_EXAMES =
  'ATUALIZAR_LISTAGEM_MULTIPLOS_EXAMES';
export const atualizarListagemMultiplosExames = listagem => ({
  type: ATUALIZAR_LISTAGEM_MULTIPLOS_EXAMES,
  payload: {
    listagemMultiplosExames: listagem
  }
});

export const PREENCHER_NAO_CONFORMIDADES = 'PREENCHER_NAO_CONFORMIDADES';
export const preencherNaoConformidades = inconformidades => ({
  type: PREENCHER_NAO_CONFORMIDADES,
  payload: {
    inconformidades: inconformidades
  }
});
export const PREENCHER_HISTORICO_INCONFORMIDADES =
  'PREENCHER_HISTORICO_INCONFORMIDADES';
export const preenhcerHistoricoInconformidades = historico => ({
  type: PREENCHER_HISTORICO_INCONFORMIDADES,
  payload: {
    historico: historico
  }
});
export const PREENCHER_TOTAL_NAO_CONFORMIDADES =
  'PREENCHER_TOTAL_NAO_CONFORMIDADES';
export const preencherTotalNaoConformidades = total => ({
  type: PREENCHER_TOTAL_NAO_CONFORMIDADES,
  payload: {
    totalNaoConformidades: total
  }
});
export const EXAME_FINALIZADO = 'EXAME_FINALIZADO';
export const exameFinalizado = exameFinalizado => ({
  type: EXAME_FINALIZADO,
  payload: {
    exameFinalizado: exameFinalizado
  }
});
export const EXAME_ENTREGUE = 'EXAME_ENTREGUE';
export const exameEntregue = exameEntregue => ({
  type: EXAME_ENTREGUE,
  payload: {
    exameEntregue: exameEntregue
  }
});
export const PREENCHER_GRUPO_USUARIO = 'PREENCHER_GRUPO_USUARIO';
export const preencherGrupoUsuario = grupoUsuarios => ({
  type: PREENCHER_GRUPO_USUARIO,
  payload: {
    grupoUsuarios: grupoUsuarios
  }
});
export const PREENCHER_PLAINTEXT = 'PREENCHER_PLAINTEXT';
export const preencherPlainText = plainTextLaudo => ({
  type: PREENCHER_PLAINTEXT,
  payload: {
    plainTextLaudo: plainTextLaudo
  }
});
export const PREENCHER_DRAGGABLE_PANEL_CONTENT =
  'PREENCHER_DRAGGABLE_PANEL_CONTENT';
export const preencherDraggablePanelContent = (
  draggablePanelContent,
  draggablePanelTitle
) => ({
  type: PREENCHER_DRAGGABLE_PANEL_CONTENT,
  payload: {
    draggablePanelContent: draggablePanelContent,
    draggablePanelTitle: draggablePanelTitle
  }
});
export const ATUALIZAR_LISTAGEM_RASTREABILIDADE =
  'ATUALIZAR_LISTAGEM_RASTREABILIDADE';
export const atualizarListagemRastreabilidade = listagemRastreabilidade => ({
  type: ATUALIZAR_LISTAGEM_RASTREABILIDADE,
  payload: {
    listagemRastreabilidade: listagemRastreabilidade
  }
});
export const MEDICO_PADRAO_MACROSCOPIA = 'MEDICO_PADRAO_MACROSCOPIA';
export const medicoPadraoMacroscopia = medicoPadraoMacroscopia => ({
  type: MEDICO_PADRAO_MACROSCOPIA,
  payload: {
    medicoPadraoMacroscopia: medicoPadraoMacroscopia
  }
});
export const ATUALIZAR_STATUS_ETAPAS_LAUDO = 'ATUALIZAR_STATUS_ETAPAS_LAUDO';
export const atualizarStatusDasEtapasDoLaudo = (etapas, laudo) => ({
  type: ATUALIZAR_STATUS_ETAPAS_LAUDO,
  payload: {
    etapas: etapas,
    laudo: laudo
  }
});
export const EVENTO_KEYUP_DISPARADO_EDITOR = 'EVENTO_KEYUP_DISPARADO_EDITOR';
export const eventokeyUpFoiDisparadoNoEditor = eventokeyUpFoiDisparadoNoEditor => ({
  type: EVENTO_KEYUP_DISPARADO_EDITOR,
  payload: {
    eventokeyUpFoiDisparadoNoEditor: eventokeyUpFoiDisparadoNoEditor
  }
});
export const EDITOR_INICIALIZADO = 'EDITOR_INICIALIZADO';
export const editorInicializado = editorInicializado => ({
  type: EDITOR_INICIALIZADO,
  payload: {
    editorInicializado: editorInicializado
  }
});
export const ATUALIZAR_NUMERO_EXAME = 'ATUALIZAR_NUMERO_EXAME';
export const atualizarNumeroExameDoLaudoNaListagem = (laudo, numeroExame) => ({
  type: ATUALIZAR_NUMERO_EXAME,
  payload: {
    laudo,
    numeroExame
  }
});
export const ATUALIZAR_LISTAGEM_DOCUMENTOS_EXTERNOS = '';
export const atualizarListagemDocumentosExternos = listagem => ({
  type: ATUALIZAR_LISTAGEM_DOCUMENTOS_EXTERNOS,
  payload: {
    listagemDocumentosExternos: listagem
  }
});
export const ATUALIZAR_PROPS_ITEM_LISTAGEM = 'ATUALIZAR_PROPS_ITEM_LISTAGEM';
export const atualizarPropriedadeNoItemDaLista = (
  laudo,
  nomePropriedade,
  novoValor
) => ({
  type: ATUALIZAR_PROPS_ITEM_LISTAGEM,
  payload: {
    laudo,
    nomePropriedade,
    novoValor
  }
});
export const SHOW_MODAL_IMUNO = 'SHOW_MODAL_IMUNO';
export const showeModalImuno = show => ({
  type: SHOW_MODAL_IMUNO,
  payload: {
    modalRequisicaoImuno:show
  }
});
export const MUDAR_STATUS_MODAL_IMUNO = 'MUDAR_STATUS_MODAL_IMUNO';
export const mudarStatusModalImuno = laudo => ({
  type: MUDAR_STATUS_MODAL_IMUNO,
  payload: {
    laudo
  }
});
export const DADOS_HOSPITAL = 'DADOS_HOSPITAL';
export const dadosGeraisHospital = dadosGeraisHospital => ({
  type: DADOS_HOSPITAL,
  payload: {
    dadosGeraisHospital
  }
});
export const PREENCHER_HISTORICO_TOTAL_LAUDOS_ANTERIORES =
  'PREENCHER_HISTORICO_TOTAL_LAUDOS_ANTERIORES';
export const preenhcerTotalLaudosAnteriores = quantidadeLaudosAnteriores => ({
  type: PREENCHER_HISTORICO_TOTAL_LAUDOS_ANTERIORES,
  payload: {
    quantidadeLaudosAnteriores
  }
});
export const PREENCHER_USUARIOS = 'PREENCHER_USUARIOS';
export const preenhcerUsuarios = usuarios => ({
  type: PREENCHER_USUARIOS,
  payload: {
    usuarios
  }
});
export const PREENCHER_HISTORICO_TOTAL_LAUDOS_EM_ABERTO = 'PREENCHER_HISTORICO_TOTAL_LAUDOS_EM_ABERTO';
export const preencherTotalLaudosEmAberto = quantidadeLaudosEmAberto => ({
  type: PREENCHER_HISTORICO_TOTAL_LAUDOS_EM_ABERTO,
  payload: {
    quantidadeLaudosEmAberto
  }
});
export const CHANGE_RTF = 'CHANGE_RTF';
export const changeRtf = rtf => ({
  type: CHANGE_RTF,
  payload: {
    rtf
  }
});

export const FECHAR_TELA = 'FECHAR_TELA';
export const changeFecharTela = fecharTela => ({
  type: FECHAR_TELA,
  payload: {
    fecharTela
  }
});

export const ID_RTF = 'ID_RTF';
export const preencherIdRtf = idRtf => ({
  type: ID_RTF,
  payload: {
    idRtf
  }
});



// WEBPACK FOOTER //
// ./src/app/common/common.action.js